// Update hidden input field when dropdown option changes
document.querySelectorAll('.product-option-select').forEach(function(select) {
    select.addEventListener('change', function(event) {
        var selectedValue = event.target.value;
        var inputId = 'input-' + event.target.id;
        var hiddenInput = document.getElementById(inputId);
        if (hiddenInput) {
            hiddenInput.value = selectedValue;
        }
    });
});

// Function to update jar quantity dynamically
function updateAdditionalProduct() {
    var jarOption = document.getElementById('jar-option');
    if (!jarOption) {
        console.error('Jar option dropdown not found.');
        return;
    }

    var selectedOption = jarOption.options[jarOption.selectedIndex];
    var jarValue = selectedOption.value;
    var jarQty = parseInt(selectedOption.getAttribute('qty')) || 1; // Liquid se qty le raha hai

    // Update the custom-jar div with selected qty
    var customJarDiv = document.querySelector('.custom-jar');
    if (customJarDiv) {
        customJarDiv.setAttribute('data-qty', jarQty);
    }

    // Fixed variant ID (yahi hamesha rahega)
    var jarVariantId = 3355195768856;

    // Agar "With the Jar" select kiya gaya hai, toh add karega
    if (jarValue.includes("With the Jar")) {
        var formData = new FormData();
        formData.append('id', jarVariantId);
        formData.append('quantity', jarQty); // Jo bhi qty Liquid se aayi, wahi jayegi

        // Shopify cart me product add karna
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            console.log(`Jar added to cart with quantity: ${jarQty}`, data);
        })
        .catch(error => {
            console.error('Error adding jar to cart:', error);
        });
    }
}
